import * as React from "react";

interface Props {
  color?: string;
}

export const LogoutIcon = (props: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33334V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6667 8L11.3333 4.66667ZM2.66668 3.33333H8.00001V2H2.66668C1.93334 2 1.33334 2.6 1.33334 3.33333V12.6667C1.33334 13.4 1.93334 14 2.66668 14H8.00001V12.6667H2.66668V3.33333Z"
      fill={props.color ?? "white"}
    />
  </svg>
);
